
import React, { useState } from 'react';
import './index.css';
import { Col, Row } from 'antd';
import { addAgentCode, isBtoCFlow, redirectToOld } from '__utils/common-utils';
import { useForm } from 'react-hook-form';
import CustomRadio from 'components/custom-radio';
import { FormErrorMessageSpan, InputMintDiv } from 'views/common-styled-components';
import { SuccessButton } from 'components/button';
import { fetchPost, getFormDataFromJson } from '__utils/ajax-wrapper';
import { ENDPOINTS } from 'constants/endpoints';
import useFlashToggler from 'hooks/use-flash-toggler';
import { getCartId } from '__utils/common-utils';
import LargePopup from 'components/popup/large-popup';
import { useMediaQuery } from 'react-responsive';
import { CommonStyledComponentProps } from '__utils/type';
import styled from 'styled-components';
import { COLOR } from 'constants/colors';
import { useDispatch } from 'react-redux';
import { showOrderPopupAction } from 'components/pending-order-popup/pendingOrder.actions';
import { getAgentCode, getUserDetails, setOrgCartInfo } from '__utils/storage';
import { getEventName, Mixpanel } from '__utils/mixpanel';

interface OperationProps {
    onCancel: Function;
    folioData: any;
}

const OuterContent = styled.div<CommonStyledComponentProps>`
    background-color: ${COLOR.WHITE};
    margin: ${(props: CommonStyledComponentProps) => props.isMobile ? `16px` : `0`};
    box-shadow: 0 4px 4px 0 var(--lightGrey);
`;

const FolioInvestment: React.FC<OperationProps> = ({ onCancel, folioData }) => {
    const isMobile = useMediaQuery({ maxWidth: 767 });
    const flash = useFlashToggler();
    const dispatch = useDispatch();
    const [investmentType, setinvestmentType] = useState<string>('SIP');
    const [investmentDuration,setInvestmentDuration] = useState<any>('untilCancelled');
    const [durationVal,setDurationVal] = useState<any>(120);
    const { register, handleSubmit, formState: { errors } } = useForm({ mode: 'onChange' });

    //@purpose:- disable enable amout field based on redeem type
    const changeInvesementType = (type: string) => {
        setinvestmentType(type);
        setInvestmentDuration('untilCancelled');
    }

    const changeInvestmentDuration = (sipDuration: string) => {
        setInvestmentDuration(sipDuration);
    }

    const getSIPMaxAllowedDuration = () => {
        return 360;
    }
    const getSIPdates = () => {
        let sipDates = [];
        if (folioData?.metaData?.sipData?.length > 0) {
            const frequencyData = folioData?.metaData?.sipData.split('#');
            for (let i = 0; i < frequencyData.length; i++) {
                const sipInfoItemToks = frequencyData[i].split(',');
                if (sipInfoItemToks[0] === "MONTHLY") {
                    sipDates = sipInfoItemToks[3].split(':');
                }
            }
        }
        if (!sipDates.length) {
            var dates = [];
            for (let j = 1; j <= 28; j++) dates.push("" + j);
            sipDates = dates;
        }

        return sipDates;
    }
    
    const saveInvestMoreDetails = (investMoreData: any) => {

        const dataToSave = {
            schemeId: folioData?.metaData?.schemeId,
            cartId: getCartId(),
            investmentType: investMoreData.type,
            investmentFrequency: investMoreData.type == 'SIP' ? 1 : 0,
            numOfSipInstallments: investMoreData.type == 'SIP' ? (investMoreData.duration == 'untilCancelled' ? 360 : durationVal) : '',
            amount: investMoreData.amount,
            investmentId: investMoreData?.investmentId ?? '',
            folioNumber: folioData.folioNo,
            sipDate: investMoreData.type == 'SIP' ? investMoreData?.selectedDate: '',
            isBtoCFlow: isBtoCFlow()
        }
        const formData = getFormDataFromJson(dataToSave);
        Mixpanel.track(getEventName("investMore" ,"clicked","portfolioInvest"), {
            agentCode: getAgentCode(),
            user: getUserDetails(),
            investmentDuration: investMoreData.duration
        });

        fetchPost(ENDPOINTS.POST_SAVE_INVESTMENT_DETAILS, formData, null, true
        ).then((response: any) => {            
            if (response?.operationMessage === "success") {
                setOrgCartInfo(response?.responseData);
                redirectToOld(addAgentCode('cart-review'));
            } 
            else if(response?.operationMessage === 'failure' && !response?.errorEnum  && (typeof(response?.responseData) =='object' && response?.responseData?.length >0) ){
                dispatch(showOrderPopupAction());
            }
            else {
                flash.error(response?.responseData);
            }
        }).catch((error: any) => {
            flash.error("Something went wrong. Please try again later");
        })
    }


    const popupContent = () => {
        return (
            <div className={isMobile ? 'p16': 'p24'}>
                <form name="investMoreForm" onSubmit={handleSubmit(saveInvestMoreDetails)}>
                    <div className="additional-fund">
                        <p>{folioData?.metaData?.schemeShortName}</p>
                        <span>Folio : {folioData?.folioNo}</span>
                    </div>
                    <div className={ isMobile ? "" : "mint-flex" }>
                        <div className='ant-col-md-12'>
                            <p className="mt24">How would you like to invest</p>
                            <Row className='mb24 mt8'>
                                {(folioData?.metaData?.minSipAmount > 0 && folioData?.metaData?.sipData?.length) && <Col>
                                    <CustomRadio
                                        name='type'
                                        value="SIP"
                                        defaultChecked
                                        radiobuttonRef={register()}
                                        onChange={(event: any) => changeInvesementType(event.target.value)}
                                        label="SIP"
                                    />
                                </Col>}
                                {folioData?.metaData?.minLumpsumAmount > 0 && <Col>
                                    <CustomRadio
                                        name='type'
                                        value="Lumpsum"
                                        radiobuttonRef={register()}
                                        onChange={(event: any) => changeInvesementType(event.target.value)}
                                        label="Lumpsum"
                                    />
                                </Col>}
                            </Row>
                        </div>
                        {investmentType === 'SIP' &&
                        <div className='ant-col-md-12'>
                            <p className="mt24">Investment duration</p>
                            <Row className='mb24 mt8'>
                                {(folioData?.metaData?.minSipAmount > 0 && folioData?.metaData?.sipData?.length) && <Col>
                                    <CustomRadio
                                        name='duration'
                                        value="untilCancelled"
                                        defaultChecked
                                        radiobuttonRef={register()}
                                        onChange={(event: any) => changeInvestmentDuration(event.target.value)}
                                        label="Until Cancelled"
                                    />
                                </Col>}
                                {folioData?.metaData?.minLumpsumAmount > 0 && <Col>
                                    <CustomRadio
                                        name='duration'
                                        value="fixedDuration"
                                        radiobuttonRef={register()}
                                        onChange={(event: any) => changeInvestmentDuration(event.target.value)}
                                        label="Fixed Duration"
                                    />
                                </Col>}
                            </Row>
                        </div>}
                    </div>
                    {
                       investmentType && <div className='mb24'>
                        <Row gutter={16}>
                            <Col xs={24} md={12}>
                                <InputMintDiv>
                                    <div>{investmentType === 'SIP' ? 'Monthly SIP amount' : 'Lumsum amount'}</div>
                                    <input
                                        name='amount'
                                        type="number"
                                        step={1}
                                        steps-over-m={3}
                                        ref={register({
                                            required: {
                                                value: true,
                                                message: 'Please enter amount'
                                            },
                                            min: {
                                                value: 1,
                                                message: 'Minimum amount is 1'
                                            },
                                            max: {
                                                value: 10000000,
                                                message: `Maximum amount is 10000000`
                                            },
                                            pattern: {
                                                value: /^[0-9]*$/,
                                                message: 'Enter only integers'
                                            }
                                        })}
                                    />
                                    {errors?.amount && <FormErrorMessageSpan>{errors?.amount.message}</FormErrorMessageSpan>}
                                </InputMintDiv>
                            </Col>
                            
                            {(investmentType === 'SIP' && investmentDuration === 'fixedDuration')  && <Col xs={24} md={12}>
                                <InputMintDiv>
                                    <div>Enter investment duration (in months)</div>
                                    <input
                                        name='duration'
                                        type="number"
                                        defaultValue={durationVal}
                                        onChange={e =>setDurationVal(e.target.value || 120)}
                                        ref={register({
                                            required: {
                                                value: true,
                                                message: 'Please enter duration'
                                            },
                                            min: {
                                                value: 1,
                                                message: 'Enter at least 1 month'
                                            },
                                            max: {
                                                value: getSIPMaxAllowedDuration(),
                                                message: `Enter at most ${getSIPMaxAllowedDuration()} months`
                                            },
                                            pattern: {
                                                value: /^[0-9]*$/,
                                                message: 'Enter only integers'
                                            }
                                        })}
                                    />
                                    <span className='yearsCalcForDuarInMonth'> {(durationVal%12 == 0 ? (durationVal/12) : (durationVal/12).toFixed(1))} {`${durationVal/12 == 1 ? 'year' : 'years'}`}</span>
                                    {errors?.duration && <FormErrorMessageSpan>{errors?.duration.message}</FormErrorMessageSpan>}
                                </InputMintDiv>
                            </Col>}
                        </Row>
                        {investmentType === 'SIP' && <Row>
                            <Col xs={24} md={12}>
                                <div >
                                    <label htmlFor="selectedDate">Monthly date of investment</label>
                                    <br />
                                    <select
                                        className='sipDatePicker'
                                        id="selectedDate"
                                        name="selectedDate"
                                        ref={register({
                                            required: "Please select your monthly date of investment",
                                        })}
                                    >
                                        {getSIPdates().map((element: any, index: any) => (
                                            <option value={element} key={index}>{element}</option>))
                                        }
                                    </select>
                                    {(errors?.selectedDate) ? <FormErrorMessageSpan>{errors.selectedDate.message}</FormErrorMessageSpan> : null}
                                </div>
                            </Col>
                        </Row>}
                    </div>}
                    <div className={ isMobile ? "footer" : "button-center" }>
                        <SuccessButton type="submit" >Continue</SuccessButton>
                    </div>
                </form>
            </div >
        )


    }

    return <LargePopup
        closable
        onClose={onCancel}
        modalWidth='728px'
        title='Additional Investment Details'
     >
        <OuterContent isMobile={isMobile}>
            {popupContent()}
        </OuterContent>

    </LargePopup >

};

export default FolioInvestment;

